import request from '@/utils/request'

let Enterprise_detailApi = {

  /*企业详情列表*/
  list(data) {
    return request._post('/shop/plus.enterprise_detail.Index/index', data);
},
/*添加企业详情*/
add(data) {
    return request._post('/shop/plus.enterprise_detail.Index/add', data);
},
/*修改企业详情*/
edit(data) {
    return request._post('/shop/plus.enterprise_detail.Index/edit', data);
},
/*删除企业详情*/
del(data) {
    return request._post('/shop/plus.enterprise_detail.Index/del', data);
},
/*企业详情详情*/
detail(data) {
  return request._post('/shop/plus.enterprise_detail.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.enterprise_detail.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.enterprise_detail.Setting/getSetting', data, errorback);
    },
}
export default Enterprise_detailApi;



// WEBPACK FOOTER //
// ./src/api/enterprise_detail.js